import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { callApi } from '../api';

function Dashboard({ kulup }) {
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        members: 0,
        applications: 0,
        events: 0,
        recipes: 0
    });
    const [recentLogs, setRecentLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const [membersRes, eventsRes, recipesRes, appsRes, logsRes] = await Promise.allSettled([
                    callApi('/uyeler', 'GET'),
                    callApi('/etkinlikler', 'GET'),
                    callApi('/tarifler', 'GET'),
                    callApi('/basvurular', 'GET'),
                    callApi('/admin/audit-logs', 'GET')
                ]);

                setStats({
                    members: membersRes.status === 'fulfilled' ? (membersRes.value?.items?.length || 0) : 0,
                    events: eventsRes.status === 'fulfilled' ? (eventsRes.value?.items?.length || 0) : 0,
                    recipes: recipesRes.status === 'fulfilled' ? (recipesRes.value?.items?.length || 0) : 0,
                    applications: appsRes.status === 'fulfilled' ? (appsRes.value?.items?.filter(b => b.durum === 'BEKLEMEDE')?.length || 0) : 0
                });

                if (logsRes.status === 'fulfilled' && logsRes.value?.logs) {
                    setRecentLogs(logsRes.value.logs.slice(0, 5));
                }
            } catch (err) {
                console.error('Dashboard verisi alınamadı:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    const formatTime = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const now = new Date();
        const diffMs = now - date;
        const diffMin = Math.floor(diffMs / 60000);
        const diffHour = Math.floor(diffMs / 3600000);
        const diffDay = Math.floor(diffMs / 86400000);

        if (diffMin < 1) return 'Az önce';
        if (diffMin < 60) return `${diffMin} dk önce`;
        if (diffHour < 24) return `${diffHour} saat önce`;
        if (diffDay < 7) return `${diffDay} gün önce`;
        return date.toLocaleDateString('tr-TR');
    };

    const getActionIcon = (action) => {
        if (action?.includes('Login')) return '🔐';
        if (action?.includes('POST')) return '➕';
        if (action?.includes('PUT')) return '✏️';
        if (action?.includes('DELETE')) return '🗑️';
        return '📋';
    };

    const getActionColor = (action) => {
        if (action?.includes('Login')) return 'rgba(99,102,241,0.1)';
        if (action?.includes('POST')) return 'rgba(16,185,129,0.1)';
        if (action?.includes('PUT')) return 'rgba(245,158,11,0.1)';
        if (action?.includes('DELETE')) return 'rgba(239,68,68,0.1)';
        return 'rgba(100,116,139,0.1)';
    };

    if (loading) {
        return (
            <div className="loading-state">
                <div className="spinner"></div>
                <p>Dashboard yükleniyor...</p>
            </div>
        );
    }

    return (
        <div>
            <h1 className="page-title">
                <span className="title-icon" style={{ background: 'var(--primary-bg)' }}>📊</span>
                Dashboard
            </h1>

            {/* Stat Cards */}
            <div className="dashboard-grid">
                <div className="stat-card stat-members" onClick={() => navigate('/uyeler')}>
                    <div className="stat-icon">👥</div>
                    <div className="stat-value">{stats.members}</div>
                    <div className="stat-label">Toplam Üye</div>
                </div>

                <div className="stat-card stat-applications" onClick={() => navigate('/basvurular')}>
                    <div className="stat-icon">📋</div>
                    <div className="stat-value">{stats.applications}</div>
                    <div className="stat-label">Bekleyen Başvuru</div>
                </div>

                <div className="stat-card stat-events" onClick={() => navigate('/etkinlikler')}>
                    <div className="stat-icon">🎪</div>
                    <div className="stat-value">{stats.events}</div>
                    <div className="stat-label">Etkinlik</div>
                </div>

                <div className="stat-card stat-recipes" onClick={() => navigate('/tarifler')}>
                    <div className="stat-icon">🍽️</div>
                    <div className="stat-value">{stats.recipes}</div>
                    <div className="stat-label">Tarif</div>
                </div>
            </div>

            {/* Recent Activity */}
            <div className="recent-activity">
                <div className="recent-activity-header">
                    <span>📌 Son Aktiviteler</span>
                </div>
                {recentLogs.length === 0 ? (
                    <div className="notification-empty">Henüz aktivite kaydı yok.</div>
                ) : (
                    recentLogs.map((log, i) => (
                        <div className="activity-item" key={log.id || i}>
                            <div
                                className="activity-icon"
                                style={{ background: getActionColor(log.action) }}
                            >
                                {getActionIcon(log.action)}
                            </div>
                            <div className="activity-content">
                                <div className="activity-text">
                                    <strong>{log.userCode || 'Sistem'}</strong> — {log.endpoint || log.details}
                                </div>
                                <div className="activity-time">{formatTime(log.createdAt)}</div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default Dashboard;
